fragment LeadSearchResultByType on Lead {
    id
    name
    initials
    htmlUrlPath
    avatarUrl
    number
    status
    priority
    assignee {
        id
        name
    }
    value {
        currency
        formattedValue {
            prefix
            formatted
            suffix
        }
    }
    contacts {
        primaryEdge {
            node {
                id
                name
                htmlUrl
            }
        }
    }
    accounts {
        primaryEdge {
            node {
                id
                name
                htmlUrl
            }
        }
    }
    assignee {
        id
        name
    }
    createdTime
}
